module.exports = __webpack_public_path__ + "img/starfighter-twin-ion-engine.ae6189f7.svg";